import { useEffect } from 'react'

export const useLogEffect = <T>(name: string, param: T) => {
	useEffect(() => {
		console.log(name, param)
	}, [param])
}